export const BRANCH_ACTIVITIES = {
  BLOCK_TITLE_NUMBER: 'BRANCH_ACTIVITIES_BLOCK_TITLE_NUMBER',
  BLOCK_TITLE: 'BRANCH_ACTIVITIES_BLOCK_TITLE',
  LINK_SHEET: 'BRANCH_ACTIVITIES_LINK_SHEET',
  BLOCK_SUBTITLE: 'BRANCH_ACTIVITIES_BLOCK_SUBTITLE',
  LETTER: 'BRANCH_ACTIVITIES_LETTER',
  GEOPOST: 'BRANCH_ACTIVITIES_GEOPOST',
  BANK: 'BRANCH_ACTIVITIES_BANK',
  NETWORK: 'BRANCH_ACTIVITIES_NETWORK',
  DIGITAL: 'BRANCH_ACTIVITIES_DIGITAL',
  BANK_DESC: 'BRANCH_ACTIVITIES_BANK_DESC',
  DIGITAL_DESC: 'BRANCH_ACTIVITIES_DIGITAL_DESC',
  GEOPOST_DESC: 'BRANCH_ACTIVITIES_GEOPOST_DESC',
  LETTER_DESC: 'BRANCH_ACTIVITIES_LETTER_DESC',
  NETWORK_DESC: 'BRANCH_ACTIVITIES_NETWORK_DESC',
  DISCOVER_GROUP_ACTIVITIES: 'BRANCH_ACTIVITIES_DISCOVER_GROUP_ACTIVITIES',
  DISCOVER_GROUP_NEWS: 'BRANCH_ACTIVITIES_DISCOVER_GROUP_NEWS',
  DISCOVER_SOCIAL_COMMITMENT: 'BRANCH_ACTIVITIES_DISCOVER_SOCIAL_COMMITMENT',
  DISCOVER_WHO_WE_ARE: 'BRANCH_ACTIVITIES_DISCOVER_WHO_WE_ARE',
};
